import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import P from '@zola/zola-ui/src/typography/Paragraphs';

import cx from 'classnames';

import styles from './crossSellCard.module.less';

export const CrossSellCard = ({
  preview,
  hed,
  cta,
  href,
  onClick,
  className,
}: {
  preview: React.ReactNode;
  hed: React.ReactNode;
  cta: React.ReactNode;
  href: string;
  onClick: () => void;
  className: string;
}) => {
  return (
    <div className={cx(styles.crossSellCard, className)}>
      <div className={styles.body}>
        <P.BodyBase>{hed}</P.BodyBase>
        <ButtonV3 component="a" href={href} onClick={onClick}>
          {cta}
        </ButtonV3>
      </div>
      <div className={cx(styles.previewContainer)}>{preview}</div>
    </div>
  );
};
